import { NAME as APP_NAME } from 'constants';
import moment from 'moment';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/ASSIGN`;

export const REDUCER_NAME = 'shipmentsAssign';
export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments`;

export const SUMMERY_REDUCER_NAME = 'shipmentsAssignSummary';
export const SUMMERY_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments/deliveries-picklist-summary`;

export const Available_After = 'availableAfter';
export const Available_Before = 'availableBefore';
export const Time_Period = 'timePeriod';

export const ROUTES = {
  ROOT: '/shipments-assign',
};

const RATIO = 0.4;
export const MARKER_SIZE = [72 * RATIO, 90 * RATIO];

export const ASSIGNABLE_STATUS = [
  {
    label: I18n.str('allStatuses', 'All Statuses'),

    value: 500,
  },

  {
    label: I18n.str('unassigned', 'UNASSIGNED'),

    value: 'UNASSIGNED',
  },

  {
    label: I18n.str('exception', 'EXCEPTION'),

    value: 'EXCEPTION',
  },
];
export const DATES = [
  {
    label: I18n.str('tomorrow', 'Tomorrow'),
    date: [moment().add(1, 'day'), moment().add(1, 'day')],
    value: 'tomorrow',
  },
  {
    label: I18n.str('today', 'Today'),
    date: [moment(), moment()],
    value: 'today',
  },
  {
    label: I18n.str('yesterday', 'Yesterday'),
    date: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    value: 'yesterday',
  },
  {
    label: I18n.str('next7Days', 'Next 7 days'),
    date: [moment(), moment().add(7, 'day')],
    value: 'next7Days',
  },
  {
    label: I18n.str('last7Days', 'Last 7 days'),
    date: [moment().subtract(7, 'days'), moment()],
    value: 'last7Days',
  },
  {
    label: I18n.str('last30Days', 'Last 30 days'),
    date: [moment().subtract(30, 'days'), moment()],
    value: 'last30Days',
  },
];

export const INITIAL_FILTERS = {
  status: 'UNASSIGNED',
  spickup: DATES[0].date[1],
  epickup: DATES[0].date[1],
};
